import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { Loading } from '@itarget/shared';
import {
  clearSsoAttempt,
  hasSsoAttempt,
  isSsoEnabled,
  readHashFromLocation,
  redirectToSsoAuthorize,
} from '../utils/sso';

const SsoRedirect = () => {
  const started = useRef(false);
  const centerCostId = useSelector((state) => state.auth.cc);

  useEffect(() => {
    if (started.current) {
      return;
    }
    started.current = true;
    if (hasSsoAttempt()) {
      clearSsoAttempt();
      window.location.replace('/');
      return;
    }
    const hash = readHashFromLocation(window.location);
    redirectToSsoAuthorize(
      `${window.location.pathname}${window.location.search}`,
      centerCostId,
      hash || undefined
    );
  }, [centerCostId]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loading text="Redirecionando para o login..." />
    </div>
  );
};

const RouteContainer = ({ isProtected = false, roles = [], ...props }) => {
  const isAutenticated = useSelector((state) => state.auth.isAutenticated);
  const isAutenticating = useSelector((state) => state.auth.isAutenticating);
  const transmissionActivity = useSelector(
    (state) => state.subscription.transmissionActivity
  );
  const isOnlyStreaming = useSelector((state) => state.streaming.isOnlyStreaming);
  const centerCostId = useSelector((state) => state.auth.cc);

  if (isProtected && isAutenticating) {
    return <div>loading</div>;
  }

  if (isProtected && !isAutenticating && !isAutenticated) {
    if (isOnlyStreaming && centerCostId && transmissionActivity?.aga_id) {
      return (
        <Redirect
          to={`login/${centerCostId}?onlyStreaming=true&streaming_aga_id=${transmissionActivity?.aga_id}`}
        />
      );
    }
    if (isSsoEnabled()) {
      return <SsoRedirect />;
    }
    let to = '/';
    if (['ead', 'detail-ead'].includes(window.location.pathname.split('/')[1])) {
      to = '/ead';
    }
    return <Redirect to={to} />
  }

  return <Route {...props} />;
};

export default RouteContainer;
